import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";
import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";
import { axiosInstanceWithAbort } from "@/use/utilities/axios/app/axios-instance-with-abort";
import axios from "axios";

export async function pending(params, loading = true, options = null) {
  const data = { ...(params || {}), action: "with_pendings" };
  const axiosRequestConfig = {};
  let axiosClient;

  if (options?.cancelKey) axiosRequestConfig.cancelKey = options.cancelKey;

  if (options?.signal) axiosRequestConfig.signal = options.signal;

  if (options?.abort) axiosClient = axiosInstanceWithAbort().primoLab;
  else axiosClient = loading ? axiosInstance().primoLab : axiosInstanceWithoutLoader().primoLab;

  let pendingTestWorkQueuePhases = [];

  try {
    const response = await axiosClient.get("/test-work-queue-phases", {
      params: data,
      ...axiosRequestConfig,
      abort: options?.abort === true,
    });
    pendingTestWorkQueuePhases = response.data;
  } catch (error) {
    const isAbort = axios.isCancel(error);
    if (isAbort) {
      throw error;
    }
    throw error.response?.data?.errors || error;
  }

  return { pendingTestWorkQueuePhases };
}
